import { render } from "./field-select.vue?vue&type=template&id=fdef7d5c"
import script from "./field-select.vue?vue&type=script&lang=js"
export * from "./field-select.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__